import { useEffect } from "react";
import { WindowContent, WindowTitleBar } from "../../desktopWindow/components/DesktopWindow";
import { FileData } from "../../context/GameContext";
import ReactPlayer from "react-player";
import { useWindowTilesContext } from "desktopWindow/context/WindowTilesContext";
import { isDesktop, isMobile } from "react-device-detect";
import { FileIcon } from "./FileTile";
import { ActionBar } from "desktopWindow/components/DesktopWindow.styled";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

interface Props {
	file: FileData;
	width: number;
	height: number;
	handleFileForMobile?: () => void;
	name: string | undefined;
	openFromApp?: boolean;
}
export const VideoViewer = ({ file, height, handleFileForMobile, name, openFromApp }: Props) => {
	const { MobileWindowResized } = useWindowTilesContext();

	useEffect(() => {
		isMobile &&
			window.setTimeout(() => {
				MobileWindowResized("FileViewer", false);
			}, 50);
	}, [MobileWindowResized]);
	return (
		<>
			{(isDesktop || name) && (
				<WindowTitleBar
					icon={
						<div
							style={{
								display: "inline-block",
								width: 50,
								transform: "scale(0.5)", // Scaling down by 50%
								overflow: "hidden", // Optional, hides any overflow
							}}
						>
							<FileIcon fileData={file} invertColor />
						</div>
					}
				/>
			)}
			{!isDesktop && openFromApp && (
				<ActionBar sx={{ paddingLeft: 0, height: "68px", justifyContent: "flex-start !important" }}>
					<IconButton color="inherit" onClick={handleFileForMobile} size="large">
						<ArrowBack style={{ color: "white" }} />
					</IconButton>
				</ActionBar>
			)}
			<WindowContent
				style={{
					backgroundColor: "#eee",
					display: "flex",
					justifyContent: "center",
					alignContent: "center",
					height: isDesktop ? height : "auto",
					overflow: "hidden !important",
				}}
			>
				<div
					style={{
						width: "100%",
						height: "100%",
						display: "flex",
						alignContent: "center",
						justifyContent: "center",
						alignItems: "center",
						overflowX: "auto",
						overflowY: "hidden",
					}}
				>
					<ReactPlayer
						playing
						url={file.fileUrl}
						controls
						width={"100%"}
						height={"100%"}
						style={{ width: "100%", height: "100%", margin: "0 auto" }}
					/>
				</div>
			</WindowContent>
		</>
	);
};
